var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004990",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 11.86v.28h-6v-.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.14 4.92h-.28V2h.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 18.29v-6.23l1.11 1.13 4.36-.99c.05 0 .05.05 0 .05l-4.08 1.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.79 16.79a4.8 4.8 0 0 0 3.9-3.89l-.38.14a4.5 4.5 0 0 1-3.43 3.42z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 12.01h6.16L16.5 10.6l-1.3-4.13q-.02-.08-.04 0l.97 4.41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.84 7.27a4.8 4.8 0 0 1 3.84 3.94l-.32-.1a4.5 4.5 0 0 0-3.38-3.47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 5.71v6.23l-1.11-1.13-4.36.99c-.05 0-.05-.05 0-.05l4.08-1.31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.77 8.08a4.5 4.5 0 0 0-2.08 2.88l-.37.14a4.75 4.75 0 0 1 3.88-3.9v.01h.01l-.09.33h-.04l-.01.04q-.7.14-1.3.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 11.86v.28h6v-.28z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.14 19.08h-.28V22h.28z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.84 11.99h6.15l-1.11 1.13.97 4.4q-.02.09-.04 0l-1.3-4.12z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.32 12.79a4.8 4.8 0 0 0 3.84 3.94l-.14-.37a4.5 4.5 0 0 1-3.38-3.48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNato);
export default __webpack_public_path__ + "static/media/nato.a60e20b8e0ff1f20573e785801aabd79.svg";
export { ForwardRef as ReactComponent };